import { BRAND } from "../lib/constants";
import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="bg-[#0A0A0A] text-white border-t-4 border-[#E60012]" data-testid="main-footer">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
      <div className="md:col-span-2">
        <div className="flex items-center gap-3 mb-4">
          <img src={BRAND.logo} alt="GigDrive" className="h-12 w-auto bg-white p-1" />
          <span className="font-display font-black text-2xl">
            GigDrive<span className="text-[#E60012]">.</span>
          </span>
        </div>
        <p className="text-white/60 max-w-md leading-relaxed">
          Rental cars built for the gig economy. Insurance included, unlimited miles,
          and zero BS. Drive today, hustle harder.
        </p>
      </div>
      <div>
        <p className="gd-tag text-[#E60012] mb-4">Company</p>
        <ul className="space-y-2 text-white/70 text-sm">
          <li><a href="#how" className="hover:text-[#E60012] gd-snappy">How it works</a></li>
          <li><a href="#why" className="hover:text-[#E60012] gd-snappy">Why GigDrive</a></li>
          <li><a href="#faq" className="hover:text-[#E60012] gd-snappy">FAQ</a></li>
          <li><Link to="/apply" className="hover:text-[#E60012] gd-snappy">Apply</Link></li>
        </ul>
      </div>
      <div>
        <p className="gd-tag text-[#E60012] mb-4">Get in touch</p>
        <ul className="space-y-2 text-white/70 text-sm font-mono">
          <li>{BRAND.phone}</li>
          <li>{BRAND.email}</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10 py-5 px-5 md:px-10 max-w-[1400px] mx-auto flex flex-col md:flex-row justify-between gap-3 text-xs font-mono text-white/40">
      <span>© {new Date().getFullYear()} GIGDRIVE RENTALS, LLC · ALL RIGHTS RESERVED</span>
      <span>BUILT FOR DRIVERS · NOT FOR DEALERSHIPS</span>
    </div>
  </footer>
);
